/*
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-08 15:56:58
 * @LastEditors: xgx
 * @LastEditTime: 2022-10-08 16:16:00
 */
import req from "@/utils/request";

//  微博列表
export const selectListPage = (params) => req.post("/media-service/m/weiBo/selectListPage", params);

//  组织架构树
export const organTree = (params) => req.post("/manager-service/m/organization/organTree", params);

//  组织架构树
export const getOauth = (params) => req.post("/media-service/m/weiBo/oauth", params);

//  取消授权
export const revokeoAuth = (params) => req.post("/media-service/m/weiBo/revokeoAuth", params);

//  删除授权信息
export const deleteById = (params) => req.post("/media-service/m/weiBo/deleteById", params);